module.exports = __webpack_public_path__ + "static/assets/89a5537d9e507a6198af94b2dbea1c4f.svg";